export * from "./WordModal";
